
<opac-button *ngIf="showButton() && !disabled" type="text" (click)="load.emit()">
  {{ 'common.viewMore' | translate }}
</opac-button>